module.exports = __webpack_public_path__ + "img/Illustration-solution@2x.90d5524.png";